import * as React from 'react';
export const IcKidneyBladder = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.68 5.66a3.004 3.004 0 00-4.73-.86c-1.02.91-1.12 2.41-.58 3.66.07.17.13.35.18.54H15c-1.2 0-2.27.54-3 1.38C11.27 9.54 10.2 9 9 9h-.55c.05-.19.11-.37.18-.54.54-1.25.43-2.75-.58-3.66a3.005 3.005 0 00-4.73.86c-1.43 2.85-1.43 6.83 0 9.68A3.004 3.004 0 006.01 17c.75 0 1.53-.29 2.16-.91.92-.91 1.04-2.32.49-3.49-.21-.44-.33-1.01-.38-1.6h.73c1.1 0 2 .9 2 2v3c-1.1 0-2 .9-2 2s.9 2 2 2c0 .55.45 1 1 1s1-.45 1-1c1.1 0 2-.9 2-2s-.9-2-2-2v-3c0-1.1.9-2 2-2h.73c-.05.59-.17 1.15-.38 1.6-.55 1.17-.43 2.59.49 3.49.63.62 1.41.91 2.16.91 1.1 0 2.16-.61 2.69-1.66 1.43-2.85 1.43-6.83 0-9.68h-.02z'
      fill='currentColor'
    />
  </svg>
);
